import { useCallback } from "react";
import stringify from "fast-json-stable-stringify";

import { duration } from "@formant/core/model/duration";
import { IEventCountsByDevice } from "@formant/core/model/IEventCountsByDevice";
import { IEventFilter } from "@formant/core/model/IEventFilter";
import { IEventQuery } from "@formant/core/model/IEventQuery";

import { useTimer } from "../component/common/Timer";
import { eventStore } from "../stores";

const shortRefreshInterval = 10 * duration.second;
const longRefreshInterval = 60 * duration.second;

function calculateUpdateInterval(query: IEventQuery): number {
    // if the query has tags, use the long refresh interval
    // to alleviate request/server pressure.
    if (Object.keys(query.tags ?? {}).length > 0) {
        return longRefreshInterval;
    }

    // if the query has names, use the long refresh interval
    // to alleviate request/server pressure.
    if ((query.names ?? []).length > 0) {
        return longRefreshInterval;
    }

    return shortRefreshInterval;
}

export function useLiveEventCountsByDevice(
    eventQuery: IEventFilter,
): IEventCountsByDevice | undefined {
    const updateCount = useCallback(async () => {
        await eventStore.refreshCountsByDevice(eventQuery);
    }, [stringify(eventQuery)]);

    useTimer(updateCount, {
        interval: calculateUpdateInterval(eventQuery),
        wait: true,
    });

    return eventStore.countsByDevice(eventQuery);
}
